import { Link } from 'react-router-dom';
import { Award, Plus, Trash2 } from 'lucide-react';

import { useDeleteTastingNote, useTastingNotes } from './useTastingNotes';

export function WineTastingsPanel({ wineId }: { wineId: number }) {
  const { data: notes, isLoading } = useTastingNotes(wineId);
  const remove = useDeleteTastingNote();

  return (
    <div className="card p-4 md:p-5 space-y-3 lg:col-span-3">
      <div className="flex items-center justify-between">
        <h2 className="font-medium flex items-center gap-2">
          <Award size={16} className="text-notion-500" /> Notas de cata
        </h2>
        <Link to={`/tastings/new?wine_id=${wineId}`} className="btn-secondary text-xs">
          <Plus size={12} /> Nueva cata
        </Link>
      </div>

      {isLoading ? (
        <p className="text-sm text-notion-500">Cargando…</p>
      ) : !notes || notes.length === 0 ? (
        <div className="text-center text-notion-500 text-sm py-6 border border-dashed border-notion-200 rounded">
          Sin catas registradas. Cuando lo pruebes, anotá vista, nariz, boca y conclusión.
        </div>
      ) : (
        <ul className="divide-y divide-notion-100">
          {notes.map((n) => (
            <li key={n.id} className="py-2.5 flex items-start justify-between gap-3">
              <Link to={`/tastings/${n.id}/edit`} className="flex-1 min-w-0">
                <div className="flex items-baseline justify-between gap-2">
                  <p className="text-sm text-notion-800">
                    {new Date(n.tasted_on).toLocaleDateString('es-AR', {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric',
                    })}
                  </p>
                  {n.score != null && (
                    <span className="text-xs px-2 py-0.5 rounded-full bg-notion-100 text-notion-800 tabular-nums">
                      {n.score}/{n.scale === 'propio' ? '★' : n.scale}
                    </span>
                  )}
                </div>
                {n.conclusion && (
                  <p className="text-xs text-notion-500 line-clamp-2 mt-1">{n.conclusion}</p>
                )}
                {n.user_name && (
                  <p className="text-[11px] text-notion-400 mt-0.5">por {n.user_name}</p>
                )}
              </Link>
              <button
                type="button"
                onClick={() => {
                  if (confirm('¿Eliminar esta cata?')) remove.mutate(n.id);
                }}
                className="text-notion-400 hover:text-red-600 p-1"
                aria-label="Eliminar"
              >
                <Trash2 size={12} />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
